import styled from "styled-components"

export const Footer = styled.div`
  margin-top: 20px;
`

export const UniversityRow = styled.div`
  display: flex;
  margin-top: 0;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`

export const UniversityRowItem = styled.div`
  &:first-of-type {
    margin-bottom: 20px;
  }
`

export const ContentWrapper = styled.div`
  text-align: ${props => props.align || "center"};
`
export const EventPleaseSpecifyInput = styled.div`
  padding-top: 10px;
`
